import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { documentTitleForPath } from '../models/content';

/** Sets a unique, descriptive document.title for the current route (CIWX-103). */
export function useDocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = documentTitleForPath(pathname);
  }, [pathname]);
}
